import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../../components/contentfrom";

function Gettouch(props) {
  return (
    <div className="gettouch p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Feel Free to Discuss Your Project!</h2>
            </div>
            <p>
              TekRevol can help you turn your app idea into a reality! Our
              developers are all set to carry out your idea. Whether you're in
              the USA, UK, Canada, or the GCC. You can schedule a free
              consultation with us to get an estimate about your project as we
              discuss your requirements and goals in detail. Let’s connect with
              us to build your feature-rich React Native app!
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
